import {
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
  Component,
  inject,
} from '@angular/core';
import { DomainPageComponent, EnvironmentService } from '@technocom/core';
import { Endpoints } from '@app/shared/util/endpoints';
import { HttpObserverType, HttpResponseType, HttpService } from '@technocom/common/http';
import { DialogService } from '@technocom/ui/dialogs';
import { tap } from 'rxjs';

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaptchaComponent extends DomainPageComponent {
  @Input()
  code = '';

  @Output()
  codeChanged = new EventEmitter<string>();

  @ViewChild('captcha')
  imgCmp: ElementRef;

  captchaId: string;

  protected env = inject<EnvironmentService>(EnvironmentService);
  protected dialogService = inject(DialogService);
  private httpService = inject(HttpService);

  protected onInit(): void {
    this.getCaptcha();
    super.onInit();
  }

  onChangeCode(code: string): void {
    this.codeChanged.emit(code);
  }

  getCaptcha(): void {
    this.code = '';

    const url = Endpoints.ofRegistration('captcha');
    const req$ = this.httpService.getClient().get(url, {
      responseType: HttpResponseType.BLOB,
      observe: HttpObserverType.RESPONSE,
    });

    this.dialogService
      .wait(req$, true)
      .pipe(
        tap(response => {
          (this.imgCmp.nativeElement as HTMLImageElement).src = URL.createObjectURL(response.body);
          this.captchaId = response.headers.get('CAPTCHA_ID');
        }),
      )
      .subscribe();
  }
}
